import React from 'react';
import { useInput, useTranslate } from 'react-admin';
import { Box, Typography, Chip } from '@mui/material';
import { AMENITY_KEYS } from '../../constants/amenities';

interface AmenitiesInputProps {
    source?: string;
}

export const AmenitiesInput: React.FC<AmenitiesInputProps> = ({ source = 'amenities' }) => {
    const translate = useTranslate();
    const { field } = useInput({
        source,
        defaultValue: [],
    });

    const value: string[] = Array.isArray(field.value) ? field.value : [];

    const toggle = (key: string) => {
        const next = value.includes(key)
            ? value.filter((k) => k !== key)
            : [...value, key];
        field.onChange(next);
    };

    return (
        <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                {translate('resources.sites.fields.amenities')}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                {translate('resources.sites.helpers.amenities')}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {AMENITY_KEYS.map((key) => {
                    const selected = value.includes(key);
                    return (
                        <Chip
                            key={key}
                            label={translate(`resources.sites.amenityLabels.${key}`)}
                            clickable
                            onClick={() => toggle(key)}
                            variant={selected ? 'filled' : 'outlined'}
                            color={selected ? 'success' : 'default'}
                            sx={{
                                fontWeight: selected ? 600 : 400,
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
};
